/**
 * About page data
 * Centralized location for easy maintenance and updates
 */

export const stats = [
  { number: '99%', label: 'Visa Success Rate', icon: '✅' },
  { number: '1000+', label: 'Students Assisted', icon: '🎓' },
  { number: '5', label: 'Countries Supported', icon: '🌍' },
  { number: '7+', label: 'Years of Experience', icon: '⭐' }
];

export const values = [
  {
    icon: '🤝',
    title: 'Transparency First',
    description: 'Contract-based services with clear pricing. No hidden fees, no surprises.'
  },
  {
    icon: '🎯',
    title: 'Student Success',
    description: 'Your success is our success. We maintain a 99% success rate for qualified applicants.'
  },
  {
    icon: '🌐',
    title: 'Global Presence',
    description: 'Offices in Sri Lanka, Germany, and Canada providing local expertise and support.'
  },
  {
    icon: '💼',
    title: 'Professional Excellence',
    description: 'Handled by immigration experts and legal professionals in destination countries.'
  }
];

export const timeline = [
  {
    year: '2017',
    title: 'Founded',
    description: 'Ravana Migration established as a division of Ravana Industries Pvt Ltd'
  },
  {
    year: '2019',
    title: 'Global Expansion',
    description: 'Opened offices in Germany and Canada'
  },
  {
    year: '2022',
    title: 'Service Expansion',
    description: 'Extended services to Australia, UK, and New Zealand'
  },
  {
    year: '2024',
    title: 'Flight Plan™ Alliance Partner',
    description: 'Launched unified platform for 5-country migration services'
  }
];

export const offices = [
  {
    country: 'Sri Lanka',
    flag: '🇱🇰',
    city: 'Colombo',
    role: 'Headquarters',
    address: 'No 10/30/1/1, Pamankada Lane, Wellawatta, Colombo 06'
  },
  {
    country: 'Germany',
    flag: '🇩🇪',
    city: 'Multiple Cities',
    role: 'European Operations',
    address: 'On-ground support across Germany'
  },
  {
    country: 'Canada',
    flag: '🇨🇦',
    city: 'Multiple Cities',
    role: 'North American Operations',
    address: 'Local support across Canadian provinces'
  }
];

export const recognitions = [
  { icon: '🏆', text: 'Fintiba Official Partner' },
  { icon: '✅', text: '99% Success Rate' },
  { icon: '⭐', text: '5.0 Google Reviews' },
  { icon: '🎓', text: 'University Network Partner' }
];

/**
 * About page highlights
 */
export const aboutHighlights = [
  {
    title: 'Founded',
    value: '2017',
    description: 'Years of experience',
    icon: '📅'
  },
  {
    title: 'Offices',
    value: '3',
    description: 'Countries worldwide',
    icon: '🏢'
  },
  {
    title: 'Students',
    value: '1000+',
    description: 'Successfully placed',
    icon: '🎓'
  },
  {
    title: 'Success Rate',
    value: '99%',
    description: 'Visa approval rate',
    icon: '✅'
  }
];
